// Warning: Enum values used as translation keys
export enum SearchType {
  Location = 'location',
  MeetingRoom = 'meeting-room',
  Coworking = 'coworking',
}
